import { React, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Pagination } from "swiper";
import "swiper/css";
import { SVGIcons, ImgIcons, Imgbanner, getcolors } from "../../Helpers/Common";
import { Link } from "react-router-dom";
import { Showdetailspopup } from "../Showdetailspopup/Showdetailspopup";

var SVGIcon = "";
SVGIcons().then((resultData) => (SVGIcon = resultData));

export function Layout8(props) {
  const [showdetails, setshowdetails] = useState(false);
  const [details, setdetails] = useState(false);

  function showdetailspop(data) {
    setshowdetails(true);
    setdetails(data);
  }

  let Closepopup = () => {
    setshowdetails(false);
  };

  return (
    <>
      <section className="mb-0">
        <div className="temp19">
          <div className="head">
            <h3>
              {props.title.display_title}
              <span className="red">{props.title.display_title_sufix}</span>
            </h3>
            {props.title.show_more ? (
              <Link to={"baypage/" + props.title.slug}>
                {" "}
                <img src={SVGIcon["right-arrow.svg"]} />{" "}
              </Link>
            ) : null}
          </div>
          <div className="temp19-area">
            <Swiper
              slidesPerView={2.4}
              spaceBetween={16}
              freeMode={true}
              loop={false}
              loopFillGroupWithBlank={true}
              centeredSlides={false}
              modules={[FreeMode, Pagination]}
              className="temp19-slider"
            >
              {props.Layout1.map((data, index) => {
                var bgcolors = getcolors;
                var random = Math.floor(Math.random() * bgcolors.length);
                if (data.content_bg_color != "#000000") {
                  var bgcolor = { backgroundColor: data.content_bg_color };
                } else {
                  var bgcolor = { backgroundColor: bgcolors[random] };
                }
                var premium = "";
                if (data.premium && !data.original_tag) {
                  var premium = (
                    <img
                      src="https://dbcms.docubay.com/media-upload/1691135448-golden-d-new.png"
                      style={{
                        width: "1rem",
                        "margin-bottom": "5px",
                        "margin-rigth": "10px",
                        "border-radius": "0px",
                      }}
                    />
                  );
                }
                if (data.original_tag && data.premium) {
                  var original = <img src={SVGIcon["Premvg.svg"]} />;
                }
                var GenereTitle = data.genres.split(",");
                GenereTitle = GenereTitle[0];
                return (
                  <SwiperSlide key={index} className="temp19-item">
                    <a
                      onClick={() => {
                        showdetailspop(data);
                      }}
                    >
                      <div className="temp19-itemColor" style={bgcolor}>
                        <img src={data.thumbnail_image2.medium} />
                      </div>
                      <div className="bay-title">{data.keywords}</div>
                      <div className="premium-red">
                        {premium}
                        {original}
                      </div>
                    </a>
                  </SwiperSlide>
                );
              })}
              <SwiperSlide></SwiperSlide>
            </Swiper>
          </div>
        </div>
      </section>
      {showdetails ? (
        <Showdetailspopup
          data={details}
          Closebtn={Closepopup}
          silverIcon={props.silverIcon}
          goldenIcon={props.goldenIcon}
        />
      ) : null}
    </>
  );
}

export default Layout8;
